export default "__VITE_ASSET__a8e9af3b__"